import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { CurrentUserStateService } from '../../Core/Users/services/current-user-state.service';
import { userPermissionsEnum } from '../../Core/Users/enums/user-permissions.enum';

@Injectable()
export class ViActivateGuard implements CanActivate {

    constructor(
        private currentUserState: CurrentUserStateService) {
    }

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        return this.currentUserState.getAccount().pipe(
            filter(x => x !== null),
            map(account => {
                const requiredPermissions = [
                    userPermissionsEnum.openAI,
                    userPermissionsEnum.visibilityIntelligence,
                ];

                return requiredPermissions.every(p => account.permissions.includes(p));
            })
        );
    }

}
